export default __webpack_public_path__ + "static/media/40t.5afb76e1.jpg";